import { Directive, ViewContainerRef, Input } from '@angular/core';
@Directive({
    selector: '[hash]',
    standalone: true,
})
  export class HashDirective  {
    @Input() hash: string;
  
    constructor(public vcRef: ViewContainerRef) {}
  }